//@ts-nocheck

import { WebMercatorViewport } from '@deck.gl/core';
import * as h3 from 'h3-js';

export const sicLetters = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
    'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S'
  ];

export  const orderedSicLetters = [
    'L', 'F', 'G', 'J', 'N', 'M', 'I', 'S', 'C', 'Q',
    'K', 'H', 'R', 'P', 'A', 'D', 'E', 'B', 'O'
  ];

const h3CellsUK = [
'8309a0fffffffff',
'8309a4fffffffff',
'8309a6fffffffff',
'83180dfffffffff',
'831829fffffffff',
'83182dfffffffff',
'831870fffffffff',
'831872fffffffff',
'831874fffffffff',
'831875fffffffff',
'831876fffffffff',
'831901fffffffff',
'831908fffffffff',
'831909fffffffff',
'83190afffffffff',
'83190bfffffffff',
'83190cfffffffff',
'83190dfffffffff',
'83190efffffffff',
'831928fffffffff',
'831929fffffffff',
'83192afffffffff',
'83192bfffffffff',
'83192cfffffffff',
'831940fffffffff',
'831941fffffffff',
'831942fffffffff',
'831943fffffffff',
'831946fffffffff',
'831948fffffffff',
'83194afffffffff',
'83194cfffffffff',
'83194efffffffff',
'831950fffffffff',
'831951fffffffff',
'831953fffffffff',
'831954fffffffff',
'831955fffffffff',
'831956fffffffff',
'831958fffffffff',
'831959fffffffff',
'83195afffffffff',
'83195bfffffffff',
'83195cfffffffff',
'83195dfffffffff',
'83195efffffffff',
'831972fffffffff',
'831973fffffffff',
'831976fffffffff'];

let loadedCells = []
export function setLoadedCells(_loadedCells)
{
  loadedCells = _loadedCells;
}


export function getH3CellsInView({
    latitude,
    longitude,
    zoom,
    width,
    height,
    resolution = 3,
  }) {

    try {
      const viewport = new WebMercatorViewport({
        latitude,
        longitude,
        zoom,
        width,
        height,
      });
  
      const [west, north] = viewport.unproject([0, 0]);
      const [east, south] = viewport.unproject([width, height]);
  
      const viewportPolygon = [
        [south, west],
        [north, west],
        [north, east],
        [south, east],
        [south, west],
      ];
  
      const h3Cells = h3.polygonToCellsExperimental(
        viewportPolygon,
        resolution,
        h3.POLYGON_TO_CELLS_FLAGS.containmentOverlapping
      );

      // Exclude any cells not in UK, and any cells not loaded (latter for test mode etc.)
      const filteredH3Cells = h3Cells.filter(cell => h3CellsUK.includes(cell) && loadedCells.includes(cell));
      //console.log(filteredH3Cells);
      return filteredH3Cells;
    } catch (error) {
      console.error('Error in getH3CellsInView:', error);
    }
  }